/**
 * Created by JackCui on 2021/12/22
 */

export function childVm (componentName) {
  let _child = []

  function fn (componentName) {
    for (let child of this.$children) {
      let name = child.$options.name
      if (name === componentName) {
        _child.push(child)
      } else {
        fn.call(child, componentName)
      }
    }
  }
  
  fn.call(this, componentName)
  
  return _child.length === 1 ? _child[0] : _child
}

export function parentVm (componentName) {
  let parent = this || this.$root
  let name = parent.$options.name

  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent

    if (parent) {
      name = parent.$options.name
    }
  }

  return parent
}

export default {
  methods: {
    dispatch (componentName, eventName, params) {
      let parent = parentVm.call(this, componentName)
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },
    parentVm (componentName) {
      return parentVm.call(this, componentName)
    },
    broadcast (componentName, eventName, params) {
      childVm.call(this, componentName).forEach(child => {
        child.$emit.apply(child, [eventName].concat(params))
      })
    },
    childVm (componentName) {
      return childVm.call(this, componentName)
    }
  }
}
